import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "warning"]

  connect() {
    this.check()
  }

  check() {
    const anyActive = this.toggleTargets.some(el => el.checked)
    this.warningTarget.classList.toggle("hidden", anyActive)
  }
}
